import { IS_LOCAL, SENTRY_URL } from '@/constants';
import { version } from '../../package.json';

console.log('Version', version);

async function initSentry() {
  const Sentry = await import('@sentry/react');
  Sentry.init({
    dsn: SENTRY_URL,
    release: version,
  });
}

if (!IS_LOCAL) {
  initSentry();
};
